<template>
  <div class="goodsManageSet">
    <div class="banner">
      <img src="../../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">商品管理</div>
    </div>

    <div class="main_content">
      <div class="tit">商品详情设置</div>
      <div class="block">
        <h1><span class="mark">*</span>设置商品简介</h1>
        <div class="input_box">
          <van-field
            v-model="formData.intro"
            placeholder="请输入商品简介"
            maxlength="50"
          />
        </div>
      </div>

      <div class="block">
        <h1>设置商品规格信息</h1>
        <div class="textarea_box">
          <van-field
            type="textarea"
            v-model="formData.Specifications"
            placeholder="请输入商品规格信息"
            maxlength="500"
          />
        </div>
      </div>
      <div class="block">
        <h1>商品细节描述1</h1>
        <div class="textarea_box">
          <van-field
            type="textarea"
            v-model="formData.details1"
            placeholder="请输入商品细节描述1"
            maxlength="500"
          />
        </div>
      </div>
      <div class="block">
        <h1>商品细节描述2</h1>
        <div class="textarea_box">
          <van-field
            type="textarea"
            v-model="formData.details2"
            placeholder="请输入商品细节描述2"
            maxlength="500"
          />
        </div>
      </div>
      <div class="block">
        <h1>商品细节描述3</h1>
        <div class="textarea_box">
          <van-field
            type="textarea"
            v-model="formData.details3"
            placeholder="请输入商品细节描述3"
            maxlength="500"
          />
        </div>
      </div>

      <div class="block">
        <h1><span class="mark">*</span>设置商品详情信息</h1>
        <!-- 商品详情编辑内容 -->
        <div class="product_details_edit">
          <!-- 编辑内容展示 -->
          <div class="product_details_content" v-if="contents.length > 0">
            <div
              class="product_details_item"
              v-for="(item, index) in contents"
              :key="index"
            >
              <!-- 子内容操作 -->
              <div class="product_details_item_operate flex-between">
                <div class="txt">
                  {{
                    item.conttype == 1
                      ? "图片"
                      : item.conttype == 2
                      ? "视频"
                      : "文本"
                  }}
                </div>
                <div class="operate_group flex-rowr">
                  <div
                    class="btn flex-rowc"
                    :class="{ disable: index === 0 }"
                    @click="moveUp(index)"
                    :disabled="index === 0"
                  >
                    上移
                  </div>
                  <div
                    class="btn flex-rowc"
                    :class="{ disable: index === contents.length - 1 }"
                    @click="moveDown(index)"
                    :disabled="index === contents.length - 1"
                  >
                    下移
                  </div>
                  <div
                    class="btn flex-rowc"
                    :class="{ disable: index === 0 }"
                    @click="moveToTop(index)"
                    :disabled="index === 0"
                  >
                    置顶
                  </div>
                  <div class="btn flex-rowc" @click="addContent(item.sortno)">
                    新增
                  </div>
                  <div class="btn flex-rowc" @click="deleteContent(index)">
                    移除
                  </div>
                </div>
              </div>
              <!-- 子内容展示 -->
              <div class="product_details_item_content">
                <!-- 图片 -->
                <div class="pic_box" v-if="item.conttype == 1">
                  <van-uploader
                    @click-upload="clickUpload(item.id)"
                    :before-read="beforeRead"
                    :after-read="addImageContent"
                    :max-count="1"
                    class="flex-rowc"
                  >
                    <img :src="item.picurl" alt="" />
                  </van-uploader>
                </div>
                <!-- 视频 -->
                <div class="video_box" v-if="item.conttype == 2">
                  <van-uploader
                    @click-upload="clickUpload(item.id)"
                    :before-read="beforeReadVideo"
                    :after-read="addVideoContent"
                    :max-count="1"
                    class="flex-rowc"
                    accept="multiple"
                  >
                    <video :src="item.videourl" controls></video>
                  </van-uploader>
                </div>
                <!-- 文本 -->
                <div class="txt_box" v-if="item.conttype == 3">
                  <van-field
                    type="textarea"
                    v-model="item.details"
                    placeholder="请输入文字内容"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- 编辑操作 -->
          <div class="product_details_operate flex-between">
            <div class="txt">内容</div>
            <div class="operate_group flex-rowr">
              <div class="btn flex-rowc" @click="addTextContent">
                + 新增文字内容
              </div>
              <div class="btn flex-rowc">
                <van-uploader
                  :before-read="beforeRead"
                  :after-read="addImageContent"
                  :max-count="1"
                >
                  + 新增图片内容
                </van-uploader>
              </div>
              <div class="btn flex-rowc">
                <van-uploader
                  :before-read="beforeReadVideo"
                  :after-read="addVideoContent"
                  :max-count="1"
                  accept="multiple"
                >
                  + 新增视频内容
                </van-uploader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="primary-button" @click="query">保存确认</div>
    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i>返回
    </div>

    <!-- 弹窗选择新增 -->
    <van-popup v-model="isShowContentSelect" position="bottom" round>
      <div class="popup_add_wrap">
        <div class="popup_add_content">
          <div class="add_item flex-rowc" @click="addTextContent">
            <i class="iconfont icon-a-bianji2"></i> 向下添加文字
          </div>
          <div class="add_item flex-rowc">
            <van-uploader
              :before-read="beforeRead"
              :after-read="addImageContent"
              :max-count="1"
              class="flex-rowc"
            >
              <i class="iconfont icon-tupian"></i> 向下添加图片
            </van-uploader>
          </div>
          <div class="add_item flex-rowc">
            <van-uploader
              :before-read="beforeReadVideo"
              :after-read="addVideoContent"
              :max-count="1"
              class="flex-rowc"
              accept="multiple"
            >
              <i class="iconfont icon-shipinsheying"></i> 向下添加视频
            </van-uploader>
          </div>
        </div>
        <div
          class="popup_add_cancle flex-rowc"
          @click="isShowContentSelect = false"
        >
          取消
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import axios from "axios";
import {
  getCommidityDetail,
  uploadImage,
  editCommidity,
  addShopDetail,
  editShopDetail,
  delShopDetail,
  getUploadToken,
  encryptstringview,
} from "../../../api/api";
import { mapState } from "vuex";
export default {
  name: "cDetail",
  data() {
    return {
      fileList: [],
      fileList1: [],
      fileList2: [],

      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        intro: "", // 商品简介
        Specifications: "", // 商品规格描述
        details1: "",
        details2: "",
        details3: "",
      },

      cmid: "",
      isShowContentSelect: false,
      editId: "", // 修改图片、视频的id
      addIndex: "",
      oldContentsLength: 1,
      // 删除内容id
      deleteContentsId: [],
      // 编辑内容
      contents: [],
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        console.log(id, "=====--===----");
        this.cmid = id;
        this.getDetail();
      } else {
        this.$router.back();
      }
    },

    getDetail() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getCommidityDetail({ id: this.cmid }).then((res) => {
        this.formData.id = res.id ? res.id : "";
        this.formData.intro = res.intro ? res.intro : "";
        this.formData.Specifications = res.Specifications
          ? res.Specifications
          : "";

        this.contents = res.details;
        this.formData.details1 = res.details1;
        this.formData.details2 = res.details2;
        this.formData.details3 = res.details3;
        this.contents.sort((a, b) => a.sortno - b.sortno);

        Toast.clear();
      });
    },

    /**
     * 编辑商品详情
     * **/
    // 1、新增文字内容
    addTextContent() {
      let { contents, addIndex, cmid } = this;
      if (addIndex === "") {
        let sortno = contents.length + 1; // 根据数组长度设置排序值
        contents.push({
          cmid,
          sortno,
          conttype: 3,
          picurl: "",
          videourl: "",
          details: "",
        });
        // this.updateSort();
      } else {
        for (let i = addIndex; i < contents.length; i++) {
          this.contents[i].sortno++;
        }
        this.contents.splice(addIndex, 0, {
          cmid,
          sortno: addIndex + 1,
          conttype: 3,
          picurl: "",
          videourl: "",
          details: "",
        });
        this.isShowContentSelect = false;
        this.addIndex = "";
        this.updateSort(true);
      }
    },

    // 2、新增图片内容
    clickUpload(id) {
      this.editId = id;
    },
    // 图片上传之前处理
    beforeRead(file) {
      const imgformat = /image\/(png|jpg|jpeg)$/;
      if (!imgformat.test(file.type)) {
        this.$toast.fail("请上传 jpg/png 格式图片");
        return false;
      }
      return true;
    },
    // 图片上传后处理
    addImageContent(e) {
      const formData = new FormData();
      formData.append("imgfile", e.file);
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      let { contents, addIndex, cmid, editId } = this;
      uploadImage(formData).then((res) => {
        if (res.result) {
          if (editId != "") {
            contents.forEach((v) => {
              if (v.id == editId) {
                v.picurl = res.url;
              }
            });
          } else {
            if (addIndex === "") {
              let sortno = contents.length + 1; // 根据数组长度设置排序值
              contents.push({
                cmid,
                sortno,
                conttype: 1,
                picurl: res.url,
                videourl: "",
                details: "",
              });
              // this.updateSort();
            } else {
              for (let i = addIndex; i < contents.length; i++) {
                this.contents[i].sortno++;
              }
              this.isShowContentSelect = false;
              this.contents.splice(addIndex, 0, {
                cmid,
                sortno: addIndex + 1,
                conttype: 1,
                picurl: res.url,
                videourl: "",
                details: "",
              });
              this.addIndex = "";
              this.updateSort(true);
            }
          }
          Toast.clear();
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
          Toast.clear();
        }
      });
    },

    // 3、新增视频内容
    // 上传之前
    beforeReadVideo(file) {
      const imgformat = /video\/(mp4)$/;
      if (!imgformat.test(file.type)) {
        this.$toast.fail("请上传视频");
        return false;
      }
      return true;
    },
    addVideoContent(e) {
      let { contents, addIndex, cmid, editId } = this;
      getUploadToken().then((res) => {
        var formData = new FormData();
        formData.append("name", "file");
        formData.append("key", res.key);
        formData.append("policy", res.policy);
        formData.append("OSSAccessKeyId", res.OSSAccessKeyId);
        formData.append("success_action_status", "200");
        formData.append("signature", res.signature);
        formData.append("file", e.file);
        const config = {
          onUploadProgress: this.setUploadProgress, // 将方法绑定到上传进度事件上
        };
        return new Promise((resolve, reject) => {
          axios
            .post("https://upload.vwingist.com/", formData, config)
            .then((response) => {
              // 请求成功的处理
              if (response.status === 200) {
                resolve(response.data);
                //返回数据根据结果进行相应的处理
                if (editId != "") {
                  contents.forEach((v) => {
                    if (v.id == editId) {
                      v.videourl = res.host + "/" + res.key;
                    }
                  });
                } else {
                  if (addIndex === "") {
                    let sortno = contents.length + 1; // 根据数组长度设置排序值
                    contents.push({
                      cmid,
                      sortno,
                      conttype: 2,
                      picurl: "",
                      videourl: res.host + "/" + res.key,
                      details: "",
                    });
                    // this.updateSort();
                  } else {
                    for (let i = addIndex; i < contents.length; i++) {
                      this.contents[i].sortno++;
                    }
                    this.isShowContentSelect = false;
                    this.contents.splice(addIndex, 0, {
                      cmid,
                      sortno: addIndex + 1,
                      conttype: 2,
                      picurl: "",
                      videourl: res.host + "/" + res.key,
                      details: "",
                    });
                    this.addIndex = "";
                    this.updateSort(true);
                  }
                }
              } else {
                reject("请求失败");
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      });
    },
    // 设置上传进度
    setUploadProgress(event) {
      // 进度处理逻辑
      const progress = Math.round((event.loaded / event.total) * 100);
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: `上传:${progress}%`,
      });
      if (progress == 100) {
        toast.clear();
      }
      // console.log("上传进度：", progress, "%");
    },

    // 4、上移
    moveUp(index) {
      if (index > 0) {
        const tempSort = this.contents[index].sortno;
        this.contents[index].sortno = this.contents[index - 1].sortno;
        this.contents[index - 1].sortno = tempSort;
        this.contents.sort((a, b) => a.sortno - b.sortno); // 排序数组
      }
    },
    // 5、下移
    moveDown(index) {
      if (index < this.contents.length - 1) {
        const tempSort = this.contents[index].sortno;
        this.contents[index].sortno = this.contents[index + 1].sortno;
        this.contents[index + 1].sortno = tempSort;
        this.contents.sort((a, b) => a.sortno - b.sortno); // 排序数组
      }
    },
    // 6、置顶
    moveToTop(index) {
      const item = this.contents[index];
      this.contents.splice(index, 1);
      this.contents.unshift(item);
      this.updateSort(); // 更新排序属性
    },
    // 7、删除
    deleteContent(index) {
      let deletedElements = this.contents.splice(index, 1);
      if (deletedElements[0].id) {
        let arrId = [];
        arrId.push(deletedElements[0].id);
        this.deleteContentsId = this.deleteContentsId.concat(...arrId);
      }

      this.updateSort();
    },
    // 8、新增
    addContent(index) {
      this.addIndex = index;
      this.isShowContentSelect = true;
    },
    // 正常重新更新排序
    updateSort(isTrue) {
      if (isTrue) {
        this.contents.sort((a, b) => a.sortno - b.sortno);
        return;
      }
      this.contents.forEach((item, index) => {
        item.sortno = index + this.oldContentsLength;
      });
    },

    // 提交数据
    async submitData() {
      let { contents, deleteContentsId } = this;
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      this.counter = 0; // 重置计数器
      for (let i = 0; i < deleteContentsId.length; i++) {
        const item = deleteContentsId[i];
        try {
          // 在此处进行实际的提交操作，可以使用axios或其他HTTP库发送数据到服务器
          await this.deleteItem(item);
        } catch (error) {
          console.log(error, "=======");
        }
      }
      for (let i = 0; i < contents.length; i++) {
        const item = contents[i];
        try {
          // 在此处进行实际的提交操作，可以使用axios或其他HTTP库发送数据到服务器
          await this.submitItem(item);
          this.counter++; // 提交成功，计数器加1
          if (this.counter === contents.length) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success("提交成功");
            }, 200);
            // setTimeout(() => {
            //   history.back();
            // }, 1000);
          }
        } catch (error) {
          console.log(error, "=======");
        }
      }
    },
    submitItem(item) {
      if (item.id) {
        editShopDetail(item).then((res) => {
          console.log(res, "=========");
        });
      } else {
        addShopDetail(item).then((res) => {
          console.log(res, "=========");
        });
      }
    },
    deleteItem(id) {
      console.log(id, "=======");
      if (id) {
        delShopDetail(id).then((res) => {
          console.log(res, "=========res");
        });
      }
    },

    query() {
      let { formData, contents } = this;
      if (formData.intro == "") {
        this.$toast("请输入商品简介");
        return;
      }
      // if (formData.Specifications == "") {
      //   this.$toast("请输入商品规格信息");
      //   return;
      // }
      if (contents.length == 0) {
        this.$toast("请新增内容");
        return;
      }
      // const Toast = this.$toast.loading({
      //   message: "提交中...",
      //   forbidClick: true,
      // });
      editCommidity(formData).then((res) => {
        let data = res;
        if (data.result) {
          this.submitData();
          // setTimeout(() => {
          //   Toast.clear();
          //   this.$toast.success(data.message);
          // }, 500);
          // setTimeout(() => {
          //   history.back();
          // }, 1500);
        } else {
          this.$toast.fail(data.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      history.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      .textarea_box {
        .van-cell {
          padding: 10px 0;
          width: 100%;
          height: 100%;
        }
      }
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
  // 内容编辑
  .product_details_edit {
    padding: 0 50px 100px;
    font-size: 20px;
    color: #505050;
    .product_details_content {
      box-sizing: border-box;
      margin-bottom: 20px;
      .product_details_item {
        .product_details_item_operate {
          width: 100%;
          height: 60px;
          border: 1px solid #d2d2d2;
          font-size: 18px;
          padding: 0 22px;
          box-sizing: border-box;
          margin-bottom: 10px;
          .txt {
            font-size: 22px;
          }
          .operate_group {
            .btn {
              border: 1px solid #d2d2d2;
              height: 30px;
              padding: 0 14px;
              margin-left: 20px;
              &.disable {
                color: #c1c1c1;
              }
            }
          }
        }
        .product_details_item_content {
          padding: 15px 12px 40px;
          .txt_box {
            min-height: 150px;
            .van-cell {
              padding: 0;
            }
          }
          .pic_box,
          .video_box {
            padding-top: 25px;
            video {
              width: 100%;
            }
          }
        }
      }
    }
    .product_details_operate {
      border: 1px solid #d2d2d2;
      padding: 17px 21px 43px 23px;
      .txt {
        font-size: 22px;
        white-space: nowrap;
      }
      .btn {
        font-size: 18px;
        color: #ffffff;
        height: 40px;
        background: #1e1e1e;
        padding: 0 6px;
        white-space: nowrap;
        &:nth-child(2) {
          margin: 0 10px;
        }
      }
    }
  }
  .popup_add_wrap {
    font-size: 26px;
    .popup_add_content {
      .add_item {
        height: 100px;
        border-bottom: 2px solid #ededed;
        &:last-child {
          border-bottom: none;
        }
        .iconfont {
          font-size: 36px;
          margin-right: 10px;
        }
      }
    }
    .popup_add_cancle {
      height: 100px;
      border-top: 5px solid #ededed;
    }
  }
}
</style>